export const GADGET_CATEGORIES = [
    'laptop', 'desktop', 'phone', 'tablet', 'monitor', 'peripheral', 'network', 'other',
];
export const DOCUMENT_KINDS = [
    'invoice', 'bill', 'warranty', 'guarantee', 'repair', 'photo', 'other',
];
export const DISPOSAL_METHODS = [
    'resold', 'recycled', 'returned_to_supplier', 'written_off', 'donated',
];
export const DASHBOARD_VIEWS = [
    'status', 'category', 'warranty', 'open-repairs', 'repair-spend', 'ageing', 'recently-added', 'recently-changed',
];
export const isDashboardView = (v) => DASHBOARD_VIEWS.includes(v);
//# sourceMappingURL=vocabulary.js.map